import { sendJsonRequest } from "./utils";

export default function freezePostRequest(postId, isFrozen, sectionId, postIndex) {
    const data = {
        post_id: postId,
        action: isFrozen ? "unfreeze_post" : "freeze_post",
        section_id: sectionId,
        position: postIndex,
    };

    return sendJsonRequest("/core/roar/post_actions", "POST", data);
}
